import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useUptimeConfigProbeDeleteMutation } from "@/v2-backoffice-client/uptime/configProbe/delete/uptime.configProbe.delete.mutation"

export type UptimeConfigProbeDeleteButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  source: string
  identifier: string
  onCompleted?(): void
}

// One instance per row, so only the probe actually being deleted shows a
// spinner — a single mutation hook hoisted into the table would spin every
// row's button at once.
function UptimeConfigProbeDeleteButton(
  props: UptimeConfigProbeDeleteButtonProps,
) {
  const { source, identifier, onCompleted, ...buttonProps } = props

  const [del, { loading, error }] = useUptimeConfigProbeDeleteMutation({
    onCompleted,
  })
  errorToast(error ?? null, { title: "Failed to delete probe" })

  return (
    <ConfirmButton
      variant="ghost"
      size="tiny"
      iconSrc="trash"
      content="Delete probe"
      confirmContent="Delete this probe?"
      isLoading={loading}
      onConfirm={async () => {
        await del({ variables: { input: { source, identifier } } })
      }}
      {...buttonProps}
    />
  )
}

export default UptimeConfigProbeDeleteButton
